module.exports = ".selectedItem {\r\n    background: royalblue;\r\n}\r\n.selectedItemColor {\r\n    color: white !important;\r\n    /* More Text with .... */\r\n    white-space: nowrap;\r\n    width: 190px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.css
// module id = 965
// module chunks = 1